import { useState, useEffect } from 'react';
import './SplashLoader.css';
import { fetchLogoOnce } from '../../utils/logoService';

const API_URL = process.env.REACT_APP_API_URL || '';

function getNormalizedHost() {
  return window.location.hostname.replace(/^www\./, '');
}

function getHostTitle() {
  const host = getNormalizedHost();
  return host ? host.split('.')[0] : 'default';
}

export default function SplashLoader() {
  const hostTitle = getHostTitle();
  const [loaderLogo, setLoaderLogo] = useState(`/splash/${hostTitle}.png`);

  useEffect(() => {
    fetchLogoOnce().then(item => {
      const path = item?.loader_logo;
      if (path) {
        setLoaderLogo(path.startsWith('http') ? path : `${API_URL}/storage/${path}`);
      }
    }).catch(() => { /* keep default */ });
  }, []);

  return (
    <>
      <div className="splash-loading-mask" />
      <div className="splash-loader-box">
        <div className="splash-movie-box">
          <video
            width="100%"
            height="100%"
            autoPlay
            muted
            loop
            playsInline
            poster={loaderLogo}
          >
            <source type="video/quicktime" src={`/splash/${hostTitle}.mov`} />
            <source type="video/webm" src={`/splash/${hostTitle}.webm`} />
          </video>
        </div>
      </div>
    </>
  );
}
